"use client";
import { CommonPageBody, CommonPageHead } from "@highway/design-system";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { mbsEvents } from "../../mbsEvents";
import "../global.css";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
        },
    },
});

export default function LiveShareLayoutClient({ children }: { children: React.ReactNode }) {
    return (
        <>
            <CommonPageHead />
            <QueryClientProvider client={queryClient}>
                <CommonPageBody appName="MBS" appEvents={mbsEvents}>
                    {children}
                </CommonPageBody>
            </QueryClientProvider>
        </>
    );
}
